import { Component, Input, OnInit } from '@angular/core';
import { BehavioralAssessmentStatus } from '../../constants-types/Enums';
import { IconType } from '../../core-data-model';
import { InvitationSource } from '../../core-data-model/Assessment.model';
import { Person } from '../../core-data-model/Person.model';
import { UserProfileSettingsService } from '../../system-services';
import { TranslationService } from '../../translations/Translation.service';
import { MyBaService } from '../my-ba-profile/my-ba.service';
import { MyProfileTooltipService } from '../profile-tooltip/my-profile-tooltip.service';

@Component({
    selector: 'my-profile-person-info',
    templateUrl: 'my-profile-person-info.component.html',
    styleUrls: ['./my-profile-person-info.less'],
    standalone: false
})
export class MyProfilePersonInfoComponent implements OnInit {
    isThirdPartyUser: boolean;
    IconType = IconType;

    @Input()
    self: Person;

    @Input()
    globalNavContext = false;

    BehavioralAssessmentStatus = BehavioralAssessmentStatus;

    constructor(
        public TR: TranslationService,
        private myProfileTooltipService: MyProfileTooltipService,
        private userProfileSettingsService: UserProfileSettingsService,
        public myBaService: MyBaService
    ) {}

    ngOnInit(): void {
        this.isThirdPartyUser =
            !this.userProfileSettingsService.isUserLoggedInDefaultCompany();
    }

    get assessmentState() {
        return this.myProfileTooltipService.assessmentState;
    }

    get showMyBACover(): boolean {
        return !this.myBaService.hasViewedProfileCover();
    }

    getInvitationSource(): InvitationSource {
        return this.myProfileTooltipService.getInvitationSource();
    }

    getInvitationQueryParam() {
        return this.myProfileTooltipService.getInvitationQueryParam();
    }

    async assessmentCreated(assessment: { id: string; url: string }) {
        this.myProfileTooltipService.setAssessmentInformation(assessment);
        await this.myProfileTooltipService.createAndSubscribeToPoll();
    }
}
